import script from "./ACounter.vue?vue&type=script&setup=true&lang=js"
export * from "./ACounter.vue?vue&type=script&setup=true&lang=js"

import "./ACounter.vue?vue&type=style&index=0&id=df8f7080&lang=scss"

const __exports__ = script;

export default __exports__